import "./eniNavigation.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router";
import NotificationsNavItem from "./NotificationsNavItem";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import SettingsIcon from "@mui/icons-material/SettingsSharp";
import PlayLessonIcon from "@mui/icons-material/PlayLessonSharp";
import LogoutIcon from "@mui/icons-material/LogoutSharp";
import AddAPhotoSharpIcon from "@mui/icons-material/AddAPhotoSharp";
import Modal from "react-bootstrap/Modal";
import LykioButton from "../common/LykioButton";
import { useLocation } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import FloatingLabel from "react-bootstrap/FloatingLabel";

import {
  FRONTEND_LOGIN_URL,
  CREATE_URL,
  LEADERBOARDS_URL,
  STORIES_URL,
  MESSAGES_URL,
  IDEOLOGY_URL,
  SETTINGS_URL,
  WELCOME_URL,
  SEARCH_URL,
  PLAYLISTS_URL,
  USER_MANAGEMENT_WITHOUTPARAM_URL,
  REPORTS_URL,
  LATEST_ACCESS,
  CUSTOMIZE_LYKIO_URL,
  AxiosConfig,
  AWARD_URL,
  CONTENT_MANAGEMENT_MODERATE_WITHOUTPARAM_URL,
  STORIES_FOLLOWING_URL,
  UBER_ADMIN_SETTINGS_URL,
  CONTENT_CREATION,
  CHAT_URL,
  AUTHORIZED_URL_PREFIX,
  LANGUAGES_ARRAY,
  UPDATE_LANGUAGE_URL,
  NOTIFICATION_SEVERITY_SUCCESS
} from "../../Utils/Constants";
import t from "../../Utils/Translation";
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import EmailIcon from "@mui/icons-material/Email";
import React, { useState, useEffect, useContext, useRef } from "react";
import ProfileNavItem from "./ProfileNavItem";
import ChatIcon from "@mui/icons-material/Chat";
import Tooltip from "@mui/material/Tooltip";
import { Badge, Button } from "@mui/material";
import AppsIcon from "@mui/icons-material/AppsSharp";
import axios from 'axios'
import {useSessionDurationPlatform} from "../../Utils/TimerUtils";
import changeLanguage from '../../locales/translations/TranslationUtils';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';

function EniNavigation() {

useSessionDurationPlatform()


  const dismissPopover = () => {
    document.body.click();
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const context = useContext(LykioContext);
  const group = context.group;

  const userPermissions = context.userPermissions;
  const categories = context.categories;
  const tenantProperties = context.tenantProperties;
  const userDetails = context.userDetails;
  const logo =
    tenantProperties && tenantProperties.forceRootTheme
      ? tenantProperties.rootLogo
      : tenantProperties && tenantProperties.logoS3Url
      ? tenantProperties.logoS3Url
      : "lykio_logo";

  const storiesName =
    tenantProperties && tenantProperties.storiesName
      ? tenantProperties.storiesName
      : "Stories";
  const categoriesName =
    tenantProperties && tenantProperties.categoriesName
      ? tenantProperties.categoriesName
      : "Categories";

  const showIdeology = tenantProperties && tenantProperties.showIdeology;
  // onst showGuides = tenantProperties && tenantProperties.showGuides;
  const showUserGuidesInMainNav =
    tenantProperties && tenantProperties.showUserGuidesInMainNav;
  const showMessages = tenantProperties && tenantProperties.showMessages;
  const showResetLeaderboards =
    tenantProperties && tenantProperties.showResetLeaderboards;

  const enableSchools = tenantProperties && tenantProperties.enableSchools;
  const showCategories = tenantProperties && tenantProperties.showCategories;
  const showStories = tenantProperties && tenantProperties.showStories;
  const showLeaderboards =
    tenantProperties && tenantProperties.showLeaderboards;
  const showContentManagement =
    tenantProperties && tenantProperties.showContentManagement;
    
  const showNotifications =
    tenantProperties && tenantProperties.showNotifications;
  const showMessenger = tenantProperties && tenantProperties.showMessenger;
  const showReports = tenantProperties && tenantProperties.showReports;
  const showAwardsManagement =
    tenantProperties && tenantProperties.showAwardsManagement;
  const showCustomizeLykio =
    tenantProperties && tenantProperties.showCustomizeLykio;
  const showUserManagement =
    tenantProperties && tenantProperties.showUserManagement;

  const showCreateContent =
    tenantProperties && tenantProperties.showCreateContent;

  const navigate = useNavigate();
  const location = useLocation();
  //console.log('LOCATION>>>> ',location.pathname);


  const barColour = location.pathname.includes("/test") ? "#8b0000" : 
                     location.pathname.includes("/assessment") ? "#006f4b" :
                     location.pathname.includes("/interview") ? "#0076bd" :
                     location.pathname.includes("/activit") ? "#964bb6" : 
                     location.pathname.includes("/insights") ? "#00a58c" :
                     location.pathname.includes("/lb") ? "#f8ae35"
                     : "rgb(0, 61, 125)";


  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      style={{ backgroundColor: barColour }}
      variant="dark"
    >
      <div className="container-fluid eni-navigation-container" style={{ margin: "0em" }}>
        <Tooltip title={t("Home")} placement="bottom">
          <Navbar.Brand
            style={{ marginRight: "0.5em", textTransform: "uppercase" }}
            className={location.pathname==="/" ? "active-navlink eni-navigation-home hand" : "eni-navigation-home hand"}
            onClick={() => {
              navigate("/");
            }}
          >
            {t("Home")}
          </Navbar.Brand>
        </Tooltip>
        
        <HomeModal show={show} handleClose={handleClose}/>
        <Tooltip title={t("What effect does selection bias have on recruiters?")} placement="bottom">
          <Nav.Link
                style={{
                  marginRight: "4em",
                  color: "white",
                  textTransform: "uppercase",
                }}
                onClick={() => {
                  handleShow();
                }}
              >
                {t("Intro")}
          </Nav.Link>
{/*           
          <LykioButton
            style={{ width: "8em", background: "rgba(0,0,0,0.5)",  marginTop: "0em", marginRight: '6em', color:'white', textTransform: "uppercase" }}
            id="showIntro"
            variant="light"
            onClick={() => handleShow()}
          >
            Intro
          </LykioButton> */}
        </Tooltip>


        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Tooltip title={t("Posts and curiosities about biases")} placement="bottom">
              <Nav.Link
                className={location.pathname===STORIES_URL ? "active-navlink" : " "}
                style={{
                  marginRight: "0.5em",
                  color: "white",
                  textTransform: "uppercase"
                }}
                onClick={() => {
                  navigate(STORIES_URL);
                }}
              >
                {t("News")}
              </Nav.Link>
            </Tooltip>

            <Tooltip title={t("Locate your bias")} placement="bottom">
              <Nav.Link
              className={location.pathname.includes("/test") ? "active-navlink" : " "}
                style={{
                  marginRight: "0.5em",
                  color: "white",
                  textTransform: "uppercase",
                }}
                onClick={() => {
                  navigate("/test");
                }}
              >
                {t("Test")}
              </Nav.Link>
            </Tooltip>

            <Tooltip title={t("Train yourself to lead a bias-free interview with a virtual candidate")} placement="bottom">
              <Nav.Link
              className={location.pathname.includes("/interview") ? "active-navlink" : " "}
                style={{
                  marginRight: "0.5em",
                  color: "white",
                  textTransform: "uppercase",
                }}
                onClick={() => {
                  navigate("/interviews");
                }}
              >
                {t("Interview")}
              </Nav.Link>
            </Tooltip>

            <Tooltip title={t("Identify and avoid the biases that influence your evaluations")} placement="bottom">
              <Nav.Link
              className={location.pathname.includes("/assessment") ? "active-navlink" : " "}
                style={{
                  marginRight: "0.5em",
                  color: "white",
                  textTransform: "uppercase",
                }}
                onClick={() => {
                  navigate("/assessments");
                }}
              >
                {t("Assessment")}
              </Nav.Link>
            </Tooltip>

            <Tooltip title={t("Test your knowledge on biases")} placement="bottom">
              <Nav.Link
              className={location.pathname.includes("/quiz") ? "active-navlink" : " "}
                style={{
                  marginRight: "0.5em",
                  color: "white",
                  textTransform: "uppercase",
                }}
                onClick={() => {
                  navigate("/activities");
                }}
              >
                {t("Quiz")}
              </Nav.Link>
            </Tooltip>

            <Tooltip title={t("Expand your knowledge of biases")} placement="bottom">
              <Nav.Link
              className={location.pathname.includes("/insights") ? "active-navlink" : " "}
                style={{
                  marginRight: "0.5em",
                  color: "white",
                  textTransform: "uppercase",
                }}
                onClick={() => {
                  navigate("/insights");
                }}
              >
                {t("Insights")}
              </Nav.Link>
            </Tooltip>

            <Tooltip title={t("Leaderboard")} placement="bottom">
              <Nav.Link
              className={location.pathname===LEADERBOARDS_URL ? "active-navlink" : " "}
                style={{
                  marginRight: "0.5em",
                  color: "white",
                  textTransform: "uppercase",
                }}
                onClick={() => {
                  navigate(LEADERBOARDS_URL);
                }}
              >
                {t("Leaderboard")}
              </Nav.Link>
            </Tooltip>
            {userPermissions.includes("admin") && (
              <NavDropdown
                style={{ color: "white" }}
                title="Admin"
                id="collasible-nav-dropdown"
              >

                {/*userPermissions.includes("uber") && <NavDropdown.Item
                  onClick={() => {
                    navigate(`${UBER_ADMIN_SETTINGS_URL}`);
                  }}
                >
                  {t("Uber Settings")}
                </NavDropdown.Item>*/}

                {(showContentManagement && userPermissions.includes("contentmoderation")) && (
                  <NavDropdown.Item
                    onClick={() => {
                      navigate(
                        `${CONTENT_MANAGEMENT_MODERATE_WITHOUTPARAM_URL}/Stories`
                      );
                    }}
                  >
                    {t("Content Management")}
                  </NavDropdown.Item>
                )}
                {showReports && (
                  <NavDropdown.Item
                    onClick={() => {
                      navigate(REPORTS_URL);
                    }}
                  >
                    {t("Reports")}
                  </NavDropdown.Item>
                )}

                {/* {showReports && (
                  <NavDropdown.Item
                    onClick={() => {
                      navigate(LATEST_ACCESS);
                    }}
                  >
                    {t("Latest Access")}
                  </NavDropdown.Item>
                )} */}

                {/* {showAwardsManagement && (
                  <NavDropdown.Item
                    onClick={() => {
                      navigate(AWARD_URL);
                    }}
                  >
                    {t("Awards")}
                  </NavDropdown.Item>
                )} */}
                {/* {showCustomizeLykio && (
                  <NavDropdown.Item
                    onClick={() => {
                      navigate(CUSTOMIZE_LYKIO_URL);
                    }}
                  >
                    {t("Customize Lykio")}
                  </NavDropdown.Item>
                )} */}
                {(showUserManagement && userPermissions.includes("contentmoderation")) && (
                  <NavDropdown.Item
                    onClick={() => {
                      navigate(`${USER_MANAGEMENT_WITHOUTPARAM_URL}/${group}`);
                    }}
                  >
                    {t("User Management")}
                  </NavDropdown.Item>
                )}
                {/* {showCreateContent && (
                  <NavDropdown.Item
                    onClick={() => {
                      navigate(CONTENT_CREATION);
                    }}
                  >
                    {t("Content Creation")}
                  </NavDropdown.Item>
                )} */}
              </NavDropdown>
            )}
          </Nav>
          <Nav className="ml-auto">
            <li className={"meta-nav-item"}>
              <a
                className="meta-icon-button"
                onClick={() => navigate(CREATE_URL)}
              >
                <Tooltip title={t("Create Post")} placement="bottom">
                  <Badge
                    badgeContent={userDetails && userDetails.chatNotifications}
                    color="primary"
                  >
                    <AddAPhotoSharpIcon style={{color:'white'}}/>
                  </Badge>
                </Tooltip>
              </a>
            </li>

            {showMessenger && (
              <ChatNavItem
                navItemTitle={t("Chat")}
                icon={<ChatIcon />}
                link={CHAT_URL}
                userDetails={userDetails}
                leftmargin={!showStories}
                navigate={navigate}
              />
            )}

            {showNotifications && (
              <NotificationsNavItem
                leftmargin={!userPermissions.includes("createstory")}
                userDetails={userDetails}
              />
            )}

            <ProfileNavItem
              userDetails={userDetails}
              enableSchools={enableSchools}
            />
            <MoreOptionsNavItem
              dismissPopover={dismissPopover}
              navItemTitle={t("Upload Story")}
              icon={<AppsIcon />}
              navigate={navigate}
              userPermissions={userPermissions}
              userDetails={userDetails}
              tenantProperties={tenantProperties}
            />
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}

function ChatNavItem(props) {
  const userDetails = props.userDetails;

  return (
    <li
      className={
        "meta-nav-item " + (props.leftmargin && " meta-auto-left-margin")
      }
    >
      <a
        className="meta-icon-button"
        onClick={() => props.link && props.navigate(props.link)}
      >
        <Tooltip title={t("Chat")} placement="bottom">
          <Badge
            badgeContent={userDetails && userDetails.chatNotifications}
            color="primary"
          >
            {props.icon}
          </Badge>
        </Tooltip>
      </a>
    </li>
  );
}

function MoreOptionsNavItem(props) {
  const userPermissions = props.userPermissions;
  const userDetails = props.userDetails;
  const tenantProperties = props.tenantProperties;
  const showFeed = tenantProperties && tenantProperties.showFeed;
  const showCollectionsManagement =
    tenantProperties && tenantProperties.showCollectionsManagement;
  const showCollections = tenantProperties && tenantProperties.showCollections;
  const enableSchools = props.enableSchools;
  const languages = (tenantProperties && tenantProperties.languages && tenantProperties.languages.length>0) ? tenantProperties.languages : LANGUAGES_ARRAY;                  
  const [ systemLanguage, setSystemLanguage ] = useState(localStorage.getItem("i18n") ? localStorage.getItem("i18n") : 'it');

  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("showToastNotificationsToken");
    localStorage.removeItem("user");
    localStorage.removeItem("userId");
    localStorage.removeItem("localThemeName");
    localStorage.removeItem("localShowBackgroundImages");
    localStorage.removeItem("localbackgroundImage");
    localStorage.removeItem("localca");
    localStorage.removeItem("userRole");
    localStorage.removeItem("teacherbookActivated");
    localStorage.removeItem("studentbookActivated");
    localStorage.removeItem("workbookActivated");
    localStorage.removeItem("levelIsActivated");
    props.navigate(FRONTEND_LOGIN_URL);
  };

  const updateLanguageHandler = async (sysLanguage) => {
    try {
      console.log('changing to this...',sysLanguage);
      const { data } = await axios.post(
        `${AUTHORIZED_URL_PREFIX}${UPDATE_LANGUAGE_URL}`,
        { systemLanguage: sysLanguage },
        AxiosConfig()
      );
      if (data.success) {
        notify({
					title: `${t('Your language was successfully updated.')}`,
					severity: NOTIFICATION_SEVERITY_SUCCESS,
					creationDate: ''
				});
        // Get the current URL
        const currentURL = window.location.href;
        if(currentURL.includes("test1") || currentURL.includes("test2") || currentURL.includes("test3") ||
        currentURL.includes("testEN1") || currentURL.includes("testEN2") || currentURL.includes("testEN3")){
          props.navigate(`/test`);
        }
        else if(currentURL.includes("interviewgame")){
          props.navigate(`/interviews`);
        }
        else if(currentURL.includes("assessment")){
          props.navigate(`/assessments`);
        }
        else if(currentURL.includes("activity")){
          props.navigate(`/activities`);
        }
        else{
          window.location.reload();
        }
      } else {
        notify(pleaseRefreshError);
      }
    } catch (error) {
      console.log(error);
      notify(pleaseRefreshError);
    }
  }

  return (
    <PopupState
      disableAutoFocus={false}
      variant="popover"
      popupId="options-popup-popover"
    >
      {(popupState) => (
        <li className="meta-nav-item">
          <Tooltip title={t("More Options")} placement="bottom">
            <a {...bindTrigger(popupState)}>
              <div className="meta-icon-button">{props.icon}</div>
            </a>
          </Tooltip>
          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <div className="meta-navigation-options-profile">
              <Typography sx={{ p: 2 }}>
                <a
                  className="lykiocss-meta-anchor meta-navigation-options-profile"
                  onClick={() => {
                    popupState.close();
                    props.navigate(`/profile/${userDetails && userDetails.id}`);
                  }}
                >
                  <div>
                    <AccountCircleSharpIcon /> {t("Profile")}
                  </div>
                </a>
              </Typography>
            </div>

            <Typography sx={{ p: 2 }}>
              <a
                className="lykiocss-meta-anchor"
                onClick={() => {
                  popupState.close();
                  props.navigate(SETTINGS_URL);
                }}
              >
                <div>
                  <SettingsIcon /> {t("Settings")}
                </div>
              </a>
            </Typography>

            <Form.Group controlId="systemLanguage" style={{margin:'0 10px 0 10px'}}>
								<Form.Select onChange={(e) => { setSystemLanguage(e.target.value); 
                  changeLanguage(e.target.value);
                  updateLanguageHandler(e.target.value) }}>
									{languages.map((language) => (
										<option
											selected = {systemLanguage===language.code}
											value={language.code}
										>
											{t(language.name)==="English" ? "EN" : "IT"}
										</option>
									))}
								</Form.Select>
						</Form.Group>            

            {userPermissions.includes("feed") && showFeed && (
              <Typography sx={{ p: 2 }}>
                <a
                  className="lykiocss-meta-anchor"
                  onClick={() => {
                    popupState.close();
                    props.navigate(STORIES_FOLLOWING_URL);
                  }}
                >
                  <div>
                    <PlayLessonIcon /> {t("My Feed")}
                  </div>
                </a>
              </Typography>
            )}

            <Typography sx={{ p: 2 }}>
              <a
                className="lykiocss-meta-anchor"
                onClick={() => {
                  logout();
                }}
              >
                <div>
                  <LogoutIcon /> {t("Logout")}
                </div>
              </a>
            </Typography>
          </Popover>
        </li>
      )}
    </PopupState>
  );
}

// const HomeModal_ = (props)=>{

//   const show = props.show;
//   const handleClose = props.handleClose;

//   return <Modal
//   centered
//   size="lg"
//   show={show} onHide={handleClose}
// >
//   <Modal.Header closeButton>
//   </Modal.Header>
//   <Modal.Body>
//   <div style={{ minWidth: "20em", minHeight: "25em", marginLeft:'1em', marginRight:'1em' }}>
//       <h4>WELCOME!</h4>
//       <div className="lykiocss-center">
//             <video controls className="lykiocss-center" 
//             src={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Video+introduttivo+ITA.mp4" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Video+introduttivo+ENG.mp4"}
//             poster="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/intro_cover.png"
//             style={{borderRadius:'15px', maxWidth: '46em'}}>
//             </video>
//         </div>
//           <p style={{marginTop:"1em"}}>
//             {t("The selection interview is a critical moment for any organization. Research has shown that unconscious biases are one of the factors that most strongly influence the evaluations made in selection and recruitment, often leading to errors in judgment. To address this issue, we have designed a program that enables selection professionals to deepen their understanding of biases and their impact on decision-making processes. This program will help you acquire the necessary skills to manage diversity and make informed choices when recruiting new team members.")}
//           </p>
//           <p>
//             {t("The platform allows you to:")}
//             <ul>
//               <li>{t("explore the topic of biases and the underlying mechanisms of the mind that influence decision-making processes.")}</li>
//               <li>{t("engage in dialogue with virtual candidates and practice avoiding potentially discriminatory questions.")}</li>
//               <li>{t("refine your assessment skills by engaging in multi-candidate selection sessions, blind screening, and evaluator evaluations.")}</li>
//               <li>{t("assess your knowledge of bias in evaluation by taking quizzes and solving riddles")}</li>
//             </ul>
//           </p>
//           <p>
//             {t("After each activity, you will receive detailed feedback and an invitation to continue on a personalized learning path. Keep in mind that feedback is confidential; it's entirely your choice whether or not to disclose it. Start playing, share your experience with colleagues, play the activities as many time as you want to improve your performance, track your progress, and let us know your favorite content. Additionally, you can post news and information that you think might be of interest to others.")}
//           </p>
//           <p>
//             {t("And now, watch this short introductory video and get in the game!!!")}
//           </p>

//     </div>
//   </Modal.Body>
// </Modal>
// }

const HomeModal = (props) => {

  const show = props.show;
  const handleClose = props.handleClose;

  return <Modal
  centered
  size="lg"
  show={show} 
  onHide={handleClose}
  fullscreen
  style={{ overflow: "hidden" }}
>

  <Modal.Header 
    closeButton 
    style={{ 
      position: "sticky", 
      top: 0, 
      backgroundColor: "white", 
      zIndex: 1,
      borderBottom: "2px solid #f0f0f0"
    }}
  >
    <Modal.Title style={{ color: "black", fontWeight: "bold" }}></Modal.Title>
  </Modal.Header>
  
  <Modal.Body className="lykiocss-home" style={{ padding: '2em' }}>

  <h4 style={{ marginBottom: '1em', fontSize: '2.5em', textAlign: 'center', textShadow: '2px 1px 1px rgba(0,0,0,1)' }}>WELCOME!</h4>

      <div className="lykiocss-center" style={{ margin: "1rem 0" }}>
        <video 
          controls 
          className="lykiocss-center" 
          src={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Video+introduttivo+ITA.mp4" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Video+introduttivo+ENG.mp4"}
          poster="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/intro_cover.png"
          style={{
            borderRadius: "15px", 
            maxWidth: "46em", 
            width: "100%",
            height: "auto"
          }}>
        </video>
      </div>

      <div style={{ 
  background: "rgba(255, 255, 255, 0.2)",  // Transparent white
  color: "black",
  borderRadius: "8px",
  padding: "1rem",
  boxShadow: "0 4px 12px rgba(0,0,0,0.2)", // Stronger shadow for depth
  backdropFilter: "blur(10px)", // Glass effect
  WebkitBackdropFilter: "blur(10px)", // Safari support
  border: "1px solid rgba(255, 255, 255, 0.3)" // Light border for contrast
}}>

      <div style={{ 
        marginTop: "1rem",
        lineHeight: "1.6",
        fontSize: "1rem"
      }}>
          <p style={{ marginTop: "1.5em", fontSize: '1.1em', lineHeight: '1.5' }}>
          {t("The selection interview is a critical moment for any organization. Research has shown that unconscious biases are one of the factors that most strongly influence the evaluations made in selection and recruitment, often leading to errors in judgment. To address this issue, we have designed a program that enables selection professionals to deepen their understanding of biases and their impact on decision-making processes. This program will help you acquire the necessary skills to manage diversity and make informed choices when recruiting new team members.")}
          </p>
          <p style={{ fontSize: '1.1em', lineHeight: '1.5' }}>
            {t("The platform allows you to:")}
            <ul>
              <li>{t("explore the topic of biases and the underlying mechanisms of the mind that influence decision-making processes.")}</li>
              <li>{t("engage in dialogue with virtual candidates and practice avoiding potentially discriminatory questions.")}</li>
              <li>{t("refine your assessment skills by engaging in multi-candidate selection sessions, blind screening, and evaluator evaluations.")}</li>
              <li>{t("assess your knowledge of bias in evaluation by taking quizzes and solving riddles")}</li>
            </ul>
          </p>
          <p style={{ fontSize: '1.1em', lineHeight: '1.5'}}>
            {t("After each activity, you will receive detailed feedback and an invitation to continue on a personalized learning path. Keep in mind that feedback is confidential; it's entirely your choice whether or not to disclose it. Start playing, share your experience with colleagues, play the activities as many time as you want to improve your performance, track your progress, and let us know your favorite content. Additionally, you can post news and information that you think might be of interest to others.")}
          </p>


        <div style={{ 
          textAlign: "center", 
          marginTop: "2rem",
          paddingBottom: "1rem"
        }}>
          <button 
            onClick={handleClose}
            style={{
              backgroundColor: "#2d3748",
              color: "white",
              padding: "0.8rem 2rem",
              borderRadius: "25px",
              border: "none",
              cursor: "pointer",
              fontSize: "1rem",
              fontWeight: "600",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              margin: "1rem 0",
              width: "100%",
              maxWidth: "300px"
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = "#4a5568"}
            onMouseOut={(e) => e.target.style.backgroundColor = "#2d3748"}
          >
            {t("Close")}
          </button>
        </div>
      </div>
    </div>
  </Modal.Body>
</Modal>

  // return (
  //   <Modal
  //     centered
  //     // size="xl" 
  //     fullscreen={true}
  //     show={show} onHide={handleClose}
  //   >
  //     <Modal.Header closeButton>
  //     </Modal.Header>
  //     <Modal.Body className="lykiocss-home" style={{ padding: '2em' }}> {/* Added a subtle background */}
  //       <div style={{ minWidth: "25em", minHeight: "30em", marginLeft: '2em', marginRight: '2em' }}>
  //         <h4 style={{ marginBottom: '1em', fontSize: '2.5em', textAlign: 'center', textShadow: '2px 1px 1px rgba(0,0,0,1)' }}>WELCOME!</h4>
  //         <div className="lykiocss-center">
  //           <video controls className="lykiocss-center"
  //             src={localStorage.getItem("i18n") === "it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Video+introduttivo+ITA.mp4" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Video+introduttivo+ENG.mp4"}
  //             poster="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/intro_cover.png"
  //             style={{ borderRadius: '15px', maxWidth: '48em', width: '100%' }}>
  //           </video>
  //         </div>
  //         <p style={{ marginTop: "1.5em", fontSize: '1.1em', lineHeight: '1.5', textShadow: '2px 1px 1px rgba(0,0,0,1)' }}>
  //         {t("The selection interview is a critical moment for any organization. Research has shown that unconscious biases are one of the factors that most strongly influence the evaluations made in selection and recruitment, often leading to errors in judgment. To address this issue, we have designed a program that enables selection professionals to deepen their understanding of biases and their impact on decision-making processes. This program will help you acquire the necessary skills to manage diversity and make informed choices when recruiting new team members.")}
  //         </p>
  //         <p style={{ fontSize: '1.1em', lineHeight: '1.5', textShadow: '2px 1px 1px rgba(0,0,0,1)' }}>
  //           {t("The platform allows you to:")}
  //           <ul>
  //             <li>{t("explore the topic of biases and the underlying mechanisms of the mind that influence decision-making processes.")}</li>
  //             <li>{t("engage in dialogue with virtual candidates and practice avoiding potentially discriminatory questions.")}</li>
  //             <li>{t("refine your assessment skills by engaging in multi-candidate selection sessions, blind screening, and evaluator evaluations.")}</li>
  //             <li>{t("assess your knowledge of bias in evaluation by taking quizzes and solving riddles")}</li>
  //           </ul>
  //         </p>
  //         <p style={{ fontSize: '1.1em', lineHeight: '1.5', textShadow: '2px 1px 1px rgba(0,0,0,1)' }}>
  //           {t("After each activity, you will receive detailed feedback and an invitation to continue on a personalized learning path. Keep in mind that feedback is confidential; it's entirely your choice whether or not to disclose it. Start playing, share your experience with colleagues, play the activities as many time as you want to improve your performance, track your progress, and let us know your favorite content. Additionally, you can post news and information that you think might be of interest to others.")}
  //         </p>
  //       </div>
  //     </Modal.Body>
  //   </Modal>
  // )
}


export default EniNavigation;
